/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import LabeledRadioButton from '../LabeledRadioButton';
import AddressFormWithFormContext from '../AddressFormWithFormContext';
import { CountryAndStateSelectOption } from '../../../types/Configuration';

export const BillingAddressFormTestId = 'BillingAddressForm-input';

export type BillingAddressFormProps = {
  countryOptions: CountryAndStateSelectOption[];
  startWithFormOpen?: boolean;
};

const BillingAddressForm: React.FC<BillingAddressFormProps> = ({
  countryOptions,
  startWithFormOpen = false,
}: BillingAddressFormProps) => {
  const { register, control, setValue } = useFormContext();
  const [hasForcedFormOpen, setHasForcedFormOpen] = useState(false);
  const billingAddressMethodIdWatch = useWatch({
    control,
    name: 'billingAddressMethodId',
  });

  useEffect(() => {
    if (
      billingAddressMethodIdWatch === undefined ||
      (startWithFormOpen && !hasForcedFormOpen)
    ) {
      const newValue = startWithFormOpen ? '1' : '0';
      setValue('billingAddressMethodId', newValue);
      setHasForcedFormOpen(startWithFormOpen);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingAddressMethodIdWatch, startWithFormOpen, hasForcedFormOpen]);

  return (
    <div className="flex flex-col mx-auto w-full rounded-md border checkout-panel-border">
      <ul className="flex flex-col divide divide-y">
        <li className="flex flex-col p-2">
          <label htmlFor="sameAsShipping-true">
            <LabeledRadioButton
              name="billingAddressMethodId"
              value="0"
              defaultChecked={billingAddressMethodIdWatch === '0'}
              label="Same as shipping address"
              register={register}
            />
          </label>
        </li>
        <li className="flex flex-col p-2">
          <label htmlFor="sameAsShipping-false">
            <LabeledRadioButton
              name="billingAddressMethodId"
              value="1"
              defaultChecked={billingAddressMethodIdWatch === '1'}
              label="Use a different billing address"
              register={register}
            />
          </label>
          {billingAddressMethodIdWatch === '1' && (
            <AddressFormWithFormContext countryOptions={countryOptions} />
          )}
        </li>
      </ul>
    </div>
  );
};

export default BillingAddressForm;
